// src/lib/config.js
// ─────────────────────────────────────────────────────────────
// Konfigurace formuláře
// ─────────────────────────────────────────────────────────────

// Uzávěrka sběru přihlášek – 16. 8. 2026 ve 23:59 českého času (CEST).
// Lze přepsat env proměnnou REACT_APP_FORM_DEADLINE (ISO 8601 s časovou zónou).
export const FORM_DEADLINE = new Date(
  process.env.REACT_APP_FORM_DEADLINE || '2026-08-16T23:59:59+02:00',
);

export function isFormClosed() {
  return Date.now() > FORM_DEADLINE.getTime();
}
